<template>
    <span>{{ amount }}</span>
</template>

<script>
import {money} from "../Utility/filters/money";
import {percentage} from "../Utility/filters/number";

export default {
    name: "ReferralAmount",
    filters: {
        money,
        percentage
    },

    props: {
        referralScheme: {
            required: true,
            type: Object,
        },
    },


    computed: {
        amount() {

            if (this.referralScheme.side_of_benefit === 'referrer') {
                return "n/a";
            }

            if (this.referralScheme.referral_discount_type === 'percentage') {
                return this.$options.filters.percentage(this.referralScheme.referral_discount_percentage);
            }

            return this.$options.filters.money(this.referralScheme.referral_discount_absolute_amount, this.referralScheme.currency);
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/Assets/components/ReferralSchemes/ReferralAmount.vue